export const GRID_LAYOUT = 12 / 100;
